import { IUpdateable } from 'src/pods/system/interfaces';

import { updater } from 'src/utils/ObjectUpdater';
import QuestionModel from './QuestionModel';

export default class QuestionnarieModel implements IUpdateable<QuestionnarieModel> {
    public id!: number;
    public category!: string;
    public description!: string;
    public createdAt!: string;
    public updatedAt!: string;
    public questions!: QuestionModel[];

    constructor(args?: Partial<QuestionnarieModel>) {
        Object.assign(this, args);
        this.questions = args?.questions ? args.questions : [];
    }

    public update(obj: Partial<QuestionnarieModel>): QuestionnarieModel {
        return updater.update(this, obj);
    }
}
